var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4427 0H0.615235C0.291596 0 0.0292969 0.262299 0.0292969 0.585938C0.0292969 2.21764 0.72876 3.77541 1.94836 4.85951L4.51447 7.14032C4.95941 7.53582 5.21462 8.10414 5.21462 8.69957V14.4134C5.21462 14.8803 5.73647 15.1602 6.12545 14.9008L9.58237 12.5963C9.74533 12.4876 9.8433 12.3047 9.8433 12.1088V8.69957C9.8433 8.10414 10.0985 7.53582 10.5434 7.14032L13.1094 4.85951C14.329 3.77541 15.0285 2.21764 15.0285 0.585938C15.0285 0.262299 14.7662 0 14.4427 0ZM12.3309 3.98358L9.7649 6.2645C9.07002 6.88225 8.67142 7.76974 8.67142 8.69946V11.7952L6.38638 13.3185V8.69957C6.38638 7.76974 5.98778 6.88225 5.29289 6.2645L2.7269 3.98369C1.90453 3.25253 1.37959 2.25071 1.23905 1.17176H13.8187C13.6782 2.25071 13.1534 3.25253 12.3309 3.98358Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.507916a9d5e007ca63d5580aeab91028.svg";
export { ForwardRef as ReactComponent };